import { Phone } from "lucide-react"

import { formatPhoneDisplay } from "@/components/agents/setup/receptionist/phone-utils"
import { cn } from "@/lib/utils"

// IMP-387: the account's shared phone number and which agents use it. Rendered
// on Settings → Phone and reused by the Receptionist and Lead Responder setup
// screens wherever they show the account's existing number, so the display
// stays in one place.

// "Receptionist" · "Receptionist and Lead Responder" · "A, B, and C".
function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? ""
  if (names.length === 2) return `${names[0]} and ${names[1]}`
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`
}

export function PhoneNumberCard({
  phoneNumber,
  agents = [],
  className,
}: {
  phoneNumber: string
  agents?: string[]
  className?: string
}) {
  return (
    <div className={cn("rounded-lg border p-4", className)}>
      <div className="flex items-center gap-3">
        <div className="bg-muted flex h-10 w-10 shrink-0 items-center justify-center rounded-md">
          <Phone className="text-muted-foreground h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium">
            {formatPhoneDisplay(phoneNumber)}
          </p>
          {agents.length > 0 && (
            <p className="text-muted-foreground text-sm">
              Used by {joinNames(agents)}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
